export default {
	"Banner.ShopBanner": "店鋪banner",
	"Banner.MarketingMallComponentClick": "行銷商城_元件點擊",
	"Banner.MarketingMarketplace": "行銷商城"
}